import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated");
      navigate("/login");
    } catch (e2) { setErr(apiError(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md">
      <div className="mb-6 flex flex-col items-center text-center">
        <Logo size={64} />
        <h1 className="mt-4 text-2xl font-bold text-gray-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t("auth.resetTitle")}</h1>
      </div>
      <form onSubmit={submit} className="rounded-2xl border border-gray-200 bg-white p-6" data-testid="reset-form">
        {err && <div className="mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-red-600">{err}</div>}
        {!token && <div className="mb-4 rounded-xl bg-amber-50 px-4 py-3 text-sm text-amber-700">Missing reset token.</div>}
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">{t("auth.newPassword")}</label>
        <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
          className="mb-5 w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100" placeholder="••••••••" />
        <button data-testid="reset-submit-button" disabled={loading || !token}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-emerald-500 py-3.5 text-sm font-bold text-white transition-colors hover:bg-emerald-600 disabled:opacity-60">
          {loading && <Loader2 size={16} className="animate-spin" />} {t("auth.updatePassword")}
        </button>
      </form>
      <p className="mt-5 text-center text-sm">
        <Link to="/login" className="font-semibold text-emerald-600 hover:underline">{t("auth.backToLogin")}</Link>
      </p>
    </div>
  );
}
